import React from 'react';
import axios from 'axios';
import styles from '../styles/DynamicModal.module.css';

const SendFeedback = ({closeModal}) => {
  const [status, setStatus] = React.useState('');
  const [feedback, setFeedback] = React.useState('');
  const [email, setEmail] = React.useState('');

  React.useEffect(() => {
      document.body.style.overflow = 'hidden';
  
      return () => {
          document.body.style.overflow = '';
      };
  }, []);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
        axios.get('/api/user', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setEmail(response.data.email);
        }).catch(err => {
            console.error('Ошибка получения данных '+err);
        })
    }
  });

  const sendFeedback = (e) => {
    e.preventDefault();

    axios.post(`/api/feedback?email=${email}&message=${feedback}`)
    .then(() => {
      setStatus('Обращение успешно отправлено');
    })
    .catch((error) => {
      setStatus(`Ошибка отправки обращения:  ${error.response?.data.message || error.message}`);
    })
  }


  return (
    <div className={styles.liningOver}>
      <form className={styles.lining} onSubmit={(e) => sendFeedback(e)} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h1>Оставьте отзыв или опишите проблему</h1>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          <a>Введите текст обращения</a>
          <textarea cols='50' rows='10' placeholder='Опишите проблему' minLength='8' maxLength='10000' require='' value={feedback} onChange={(e) => setFeedback(e.target.value)}></textarea>
          {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
          <button className='button maxWidth black'>Отправить</button>
        </div>
      </form>
    </div>
  );
};

export default SendFeedback;
